module.exports = __webpack_public_path__ + "static/media/blog3_web.ca096943.webp";